export default __webpack_public_path__ + "static/alpaca-slider-third-image-c46310e97999f3658a58aa5c6a5ef94b.jpg";